import React from "react";

import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useForm } from "react-hook-form";

//import _uniqueId from "lodash/uniqueId";

import { useSelector, useDispatch } from "react-redux";
import { addCategory } from "../../features/personalDatabaseSlice";
import OurTextField from "../forms/OurTextField";

export default function AddCategoryDialogue(props) {
  const personalDatabaseContents = useSelector(
    (state) => state.personalDatabase.contents
  );
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  //const [dbPassword, setDbPassword] = useState('');

  const {
    //setValue,
    clearErrors,
    handleSubmit,
    //watch,
    formState: { errors },
    control,
    reset,
  } = useForm();

  const handleClickOpen = () => {
    setOpen(true);
  };

  //const [id] = useState(_uniqueId("prefix-"));
  /*
  React.useEffect(() => {
    triggerRef.current = handleClickOpen
  }, [])
  // PREP to create link-back to the dialogue open function
  // https://dilshankelsen.com/call-child-function-from-parent-component-in-react/
  */

  const handleClose = () => {
    clearErrors();
    reset();
    setOpen(false);
  };

  const onSubmit = (data) => {
    console.log(data);

    // generate unique ID - largest?
    let largestIdSofar = 0;

    // iterate through all - no guarantees re. ordering
    personalDatabaseContents.categories.forEach(function (category, index) {
      console.log(index);
      largestIdSofar = Math.max(largestIdSofar, category.id);
    });

    dispatch(
      addCategory({
        id: largestIdSofar + 1,
        name: data.categoryName,
      })
    );

    handleClose();
  };

  return (
    <>
      <Button variant="contained" component="div" onClick={handleClickOpen}>
        Add Event Category
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>Add Category</DialogTitle>
          <DialogContent>
            <DialogContentText>Please specify Category name</DialogContentText>
            <OurTextField
              autoFocus={true}
              fieldName="categoryName"
              control={control}
              errors={errors}
              label="Name"
              maxLength={500}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit(onSubmit)}>Add Event Category</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
